export default "__VITE_ASSET__DLm9kpsF__"